import axios from "axios";
import authHeader from "./jwt-token-access/auth-token-header";
import store from "../lib/store";
// import { generateSignature } from "./common";

//apply base url for axios
export const liveApi = process.env.REACT_APP_API_BASE_URL;
export const liveBetaApi = process.env.REACT_APP_BETA_API_BASE_URL;
export const stagingApi = process.env.REACT_APP_API_STAGING_BASE_URL;
export const preprodApi = process.env.REACT_APP_API_PREPROD_BASE_URL;

export const currentUrl = window.location.href;
export const API_BASE_URL =
  currentUrl.includes("staging") ||
    currentUrl.includes("localhost") ||
    currentUrl.includes("bitanicapay")
    ? stagingApi
    : currentUrl.includes("preprod")
      ? preprodApi
      : currentUrl.includes("live")
        ? liveBetaApi
        : liveApi;
const API_URL = API_BASE_URL + "/api";
export const API_VERSION = "/v1";

export const SOCKET_URL =
  currentUrl.includes("staging") || currentUrl.includes("localhost")
    ? stagingApi
    : currentUrl.includes("preprod")
      ? "https://preprod-socket.bitanicagames.com/"
      : currentUrl.includes("live")
        ? "https://beta-socket-live.bitanicagames.com/"
        : "https://socket.bitanicagames.com/";

const axiosIcoApi = axios.create({
  baseURL: API_URL + API_VERSION,
});

export const INVITE_TEL_LINK =
  currentUrl.includes("staging") || currentUrl.includes("localhost")
    ? "https://t.me/BitanicaMinesDevBot?start="
    : currentUrl.includes("preprod")
      ? "https://t.me/BitanicaMinesPreprodBot?start="
      : "https://t.me/BitanicaMinesBot?start=";

export const updateToken = (token) => {
  // axiosIcoApi.defaults.headers.common["Authorization"] = "Bearer " + token
};

export const updateCSRFToken = (token) => {
  axiosIcoApi.defaults.headers.common["csrf-token"] = token;
};

export const setupInterceptor = () => {
  axiosIcoApi.interceptors.request.use(
    (config) => {
      const UserIp = store.getState().Auth.userIp; // Get latest IP from Redux
      if (UserIp) {
        delete config.headers["x-forwarded-for"];

        config.headers["x-forwarded-for"] = UserIp.ip; // Attach IP to request headers
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
};

export const updateLanguage = (lang) => {
  axiosIcoApi.defaults.headers.common["Accept-Language"] = lang;
};

// let authToken = null
let lang;
if (typeof window !== "undefined") {
  // authToken = localStorage.getItem("authToken");
  lang = localStorage.getItem("lang");
}

// updateToken(authToken || "");
updateLanguage(lang || "");
setupInterceptor();
axiosIcoApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

const checkStatusCode = (code, err) => {
  if (code && [403, 501, 502, 503, 500, 405, 406].includes(code)) {
    if (axiosIcoApi.defaults.headers.common["token"] !== undefined) {
      // LogoutUser()
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.response.data.message);
    }
  } else {
    throw new Error(err.message);
  }
};

export async function get(url, config = {}) {
  // // Clear existing headers to avoid sending previous nonce and signature
  delete axiosIcoApi.defaults.headers.common["x-nonce"];
  delete axiosIcoApi.defaults.headers.common["x-signature"];

  // // const { signature, nonce } = await generateSignature();
  if (!config?.nonce || !config?.signature) {
    throw new Error("Signature missing!");
  }
  // if (config?.nonce && config?.signature) {
  //   axiosIcoApi.defaults.headers.common["x-nonce"] = config?.nonce;
  //   axiosIcoApi.defaults.headers.common["x-signature"] = config?.signature;
  // }

  let headers = {};
  if (config?.headers) {
    headers = { ...config.headers };
  }

  headers["x-nonce"] = config?.nonce;
  headers["x-signature"] = config?.signature;

  return await axiosIcoApi
    .get(url, {
      ...config,
      withCredentials: true,
      headers: headers,
    })
    .then((response) => {
      // if (response.data.status === "success") {
      //   return response.data
      // } else {
      //   throw new Error(response.data.message)
      // }
      return response.data;
    })
    .catch((e) => {
      const errorData = e.response?.data?.error || e.response?.data;
      if (e.response?.status === 503 && (errorData?.data?.iframe_url || errorData?.iframe_url)) {
        return errorData;
      }
      checkStatusCode(!e.response ? null : e.response.status, e);
    });
}

export async function post(url, data, config = {}) {
  // // Clear existing headers to avoid sending previous nonce and signature
  // Clear existing headers to avoid sending previous nonce and signature
  delete axiosIcoApi.defaults.headers.common["x-nonce"];
  delete axiosIcoApi.defaults.headers.common["x-signature"];

  // // const { signature, nonce } = await generateSignature();
  if (!config?.nonce || !config?.signature) {
    throw new Error("Signature missing!");
  }
  // if (config?.nonce && config?.signature) {
  //   axiosIcoApi.defaults.headers.common["x-nonce"] = config?.nonce;
  //   axiosIcoApi.defaults.headers.common["x-signature"] = config?.signature;
  // }

  let headers = {};
  if (config?.headers) {
    headers = { ...config.headers };
  }

  headers["x-nonce"] = config?.nonce;
  headers["x-signature"] = config?.signature;

  return await axiosIcoApi
    .post(url, data, { ...config, withCredentials: true, headers: headers })
    .then((response) => {
      // if (response.data.status === "success") {
      //   return response.data
      // } else {
      //   throw new Error(response.data.message)
      // }
      return response.data;
    })
    .catch((e) => {
      const errorData = e.response?.data?.error || e.response?.data;
      if (e.response?.status === 503 && (errorData?.data?.iframe_url || errorData?.iframe_url)) {
        return errorData;
      }
      checkStatusCode(!e.response ? null : e.response.status, e);
    });
}

export async function put(url, data, config = {}) {
  //Clear existing headers to avoid sending previous nonce and signature
  delete axiosIcoApi.defaults.headers.common["x-nonce"];
  delete axiosIcoApi.defaults.headers.common["x-signature"];

  // // const { signature, nonce } = await generateSignature();
  if (!config?.nonce || !config?.signature) {
    throw new Error("Signature missing!");
  }
  // if (config?.nonce && config?.signature) {
  //   axiosIcoApi.defaults.headers.common["x-nonce"] = config?.nonce;
  //   axiosIcoApi.defaults.headers.common["x-signature"] = config?.signature;
  // }

  let headers = {};
  if (config?.headers) {
    headers = { ...config.headers };
  }

  headers["x-nonce"] = config?.nonce;
  headers["x-signature"] = config?.signature;

  return axiosIcoApi
    .put(
      url,
      { ...data },
      { ...config, withCredentials: true, headers: headers },
    )
    .then((response) => {
      // if (response.data.status === "success") {
      //   return response.data
      // } else {
      //   throw new Error(response.data.message)
      // }
      return response.data;
    })
    .catch((e) => {
      const errorData = e.response?.data?.error || e.response?.data;
      if (e.response?.status === 503 && (errorData?.data?.iframe_url || errorData?.iframe_url)) {
        return errorData;
      }
      checkStatusCode(!e.response ? null : e.response.status, e);
    });
}

export async function del(url, config = {}) {
  // // Clear existing headers to avoid sending previous nonce and signature
  // Clear existing headers to avoid sending previous nonce and signature
  delete axiosIcoApi.defaults.headers.common["x-nonce"];
  delete axiosIcoApi.defaults.headers.common["x-signature"];

  // // const { signature, nonce } = await generateSignature();
  if (!config?.nonce || !config?.signature) {
    throw new Error("Signature missing!");
  }
  // if (config?.nonce && config?.signature) {
  //   axiosIcoApi.defaults.headers.common["x-nonce"] = config?.nonce;
  //   axiosIcoApi.defaults.headers.common["x-signature"] = config?.signature;
  // }

  let headers = {};
  if (config?.headers) {
    headers = { ...config.headers };
  }

  headers["x-nonce"] = config?.nonce;
  headers["x-signature"] = config?.signature;

  return await axiosIcoApi
    .delete(url, { ...config, withCredentials: true, headers: headers })
    .then((response) => {
      // if (response.data.status === "success") {
      //   return response.data
      // } else {
      //   throw new Error(response.data.message)
      // }
      return response.data;
    })
    .catch((e) => {
      const errorData = e.response?.data?.error || e.response?.data;
      if (e.response?.status === 503 && (errorData?.data?.iframe_url || errorData?.iframe_url)) {
        return errorData;
      }
      checkStatusCode(!e.response ? null : e.response.status, e);
    });
}

// File
export const postFile = (url, data) => {
  const formData = new FormData();

  Object.entries(data).map(([key, value]) => formData.append(key, value));

  const config = {
    headers: { ...authHeader(), "content-type": "multipart/form-data" },
  };

  return post(url, formData, config);
};
